module.exports = __webpack_public_path__ + "img/chart_bg.183cc33e.png";